"use strict";

module.exports = function(angularModule) {
  angularModule.service("contactDownloadModal", function($uibModal, campaignManagerService, contactDownloadService, $timeout, reactContainer) {

    this.open = function() {
      let modalInstance = $uibModal.open({
        controller: ['$scope','$uibModalInstance', function($scope, $uibModalInstance) {
          var vm = this;
          vm.state = "new"
          campaignManagerService.listCampaigns().then(function(campaigns) {
            vm.campaigns = campaigns
          })

          vm.close = function(){
            $uibModalInstance.close('cancel');
          }

          vm.startDownload = function() {
            vm.state = "pending"
            contactDownloadService.exportContacts(vm.campaignId).then(function(result) {
              vm.downloadLink = result.downloadLink
              vm.state = "complete"
            })
          }
        }],
        controllerAs: "vm",
        template: require("./contactDownloadModal.html")
      });
    }
    if(reactContainer && reactContainer.getContainer()) {
      const { setOpenDownloadContactsFn } = reactContainer.getContainer();
      if(setOpenDownloadContactsFn) {
        setOpenDownloadContactsFn(() => this.open);
      }
    }
  });
};
